import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatSelectionList } from '@angular/material/list';
import { BrandModel } from 'src/app/administration/brands/brand.model';
import { BrandService } from 'src/app/administration/brands/brand.service';

@Component({
  selector: 'app-brand',
  templateUrl: './brand.component.html',
  styleUrls: ['./brand.component.scss']
})
export class BrandComponent implements OnInit {

  selected = [];
  selectedBrandIds: Set<number> = new Set();
  isInitialized = false;
  
  @Input() brands: BrandModel[] = [];
  @Output() selectedChange: EventEmitter<any> = new EventEmitter();
  
  @ViewChild('brandsList') brandsList: MatSelectionList;

  constructor(public brandService: BrandService) { }

  ngOnInit(): void {
    // setTimeout(() => {
    //   if(this.brands && this.brands.length > 1) {
    //     this.onSelectAll();
    //   }
    // });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['brands'] && changes['brands'].currentValue) {
      setTimeout(() => {
        if (!this.isInitialized) {
          this.initializeSelection();
        } else {
          this.restoreSelection();
        }
      });
    }
  }

  initializeSelection(): void {
    if (this.brands && this.brands.length > 0) {
      this.selectedBrandIds = new Set(this.brands.map(brand => brand.id));
      if (this.brandsList) {
        this.brandsList.selectAll();
        this.onSelectionChange();
      }
    }
    this.isInitialized = true;
  }

  restoreSelection(): void {
    if (this.brandsList && this.selectedBrandIds.size > 0) {
      this.brandsList.deselectAll();
      
      this.brandsList.options.forEach(option => {
        if (this.selectedBrandIds.has(option.value.id)) {
          option.selected = true;
        }
      });
      
      this.onSelectionChange();
    }
  }

  onSelectionChange(): void {
    if (this.brandsList && this.brandsList._value) {
      this.selectedBrandIds = new Set(this.brands.map(brand => brand.id));
      this.selectedChange.emit(this.brandsList._value);
    }
  }

  onSelectAll() {
    if (!this.isChecked() || this.isIndeterminate()) {
      this.brandsList.selectAll();
    }
    else {
      this.brandsList.deselectAll();
    }
    this.onSelectionChange();
  }

  selectSpecificBrands(brandsToSelect: any[]): void {
    if (this.brandsList && brandsToSelect.length > 0) {
      this.selectedBrandIds = new Set(brandsToSelect.map(brand => brand.id));
      
      this.brandsList.deselectAll();
      
      this.brandsList.options.forEach(option => {
        if (this.selectedBrandIds.has(option.value.id)) {
          option.selected = true;
        }
      });
      
      this.onSelectionChange();
    }
  }

   isChecked(): boolean {
    if (!this.brands || this.brands.length === 0 || !this.brandsList || !this.brandsList.selectedOptions) {
      return false;
    }
    return this.brandsList.selectedOptions.selected && this.brands.length
      && this.brandsList.selectedOptions.selected.length === this.brands.length;
  }

  isIndeterminate(): boolean {
    if (!this.brandsList || !this.brands) {
      return false;
    }

    if (this.brandsList.selectedOptions.selected && this.brandsList.selectedOptions.selected.length === 0) {
      return false;
    }

    return this.brandsList.selectedOptions.selected && this.brands.length && this.brandsList.selectedOptions.selected.length
      && this.brandsList.selectedOptions.selected.length < this.brands.length;
  }
}
